import settings from './settings';
import { TOKEN } from './constants';
import { getAuthCookies } from '../config/analytics/authCookies';

export const NOT_FOUND_PAGE_EVENT = 'Not Found Page - Viewed';

export interface NotFoundTrackingPayload {
  path: string;
  previous_path: string;
  session_last_path: string;
  referrer: string;
  user_id: string;
  user_type: string;
  is_authenticated: boolean;
  is_explicit_notfound_route: boolean;
}

export const getNotFoundTrackingPayload = (
  pathname: string,
  search: string
): NotFoundTrackingPayload => {
  const authCookies = getAuthCookies();
  const token = settings.getCookie(TOKEN);

  let previousPath = '';
  let sessionLastPath = '';

  try {
    const locationStr = settings.getSession('location');
    if (locationStr) {
      const { from, to } = JSON.parse(locationStr);
      previousPath = from || '';
      sessionLastPath = to || '';
    }
  } catch {
    // ignore invalid session location
  }

  return {
    path: `${pathname}${search}`,
    previous_path: previousPath,
    session_last_path: sessionLastPath,
    referrer: typeof document !== 'undefined' ? document.referrer || '' : '',
    user_id: authCookies?.id || '',
    user_type: authCookies?.type || '',
    is_authenticated: !!(token && authCookies?.id),
    is_explicit_notfound_route: pathname === '/notfound',
  };
};
